import { gql } from "@apollo/client";

export const GET_MASTER_DATA_RAW_RETAILER_ASSOCIATIONS = gql`
  query MasterDataRawRetailerAssociations(
    $params: MasterDataRawRetailerAssociationsParamsInput!
  ) {
    masterDataRawRetailerAssociations(params: $params) {
      total
      page
      limit
      items {
        rawRetailerId
        rawRetailerName
        retailerId
        retailerName
      }
    }
  }
`;
